import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";
import { contactInfo } from "@/mocks/about";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-xl text-white mb-4">6789影视</h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              最新综艺在线观看平台，每日更新热门综艺，高清流畅，完全免费。搞笑综艺、真人秀综艺、音乐综艺、脱口秀，尽在6789影视。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">综艺分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/remen"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                >
                  热门综艺
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                {contactInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-primary-400"></i>
                {contactInfo.wechat}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-time-line text-primary-400"></i>
                {contactInfo.workingHours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 6789影视. All rights reserved.
              本站所有内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="/about"
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline"
              >
                隐私政策
              </a>
              <a
                href="/about"
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline"
              >
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}